// Import all components
import CartPage from "../pages/CartPage";
import Home from "../pages/Home";
import LoginRegister from "../pages/LoginRegister";
import ProductDetails from "../pages/ProductDetails";
import ShopFilterGrid from "../pages/ShopFilterGrid";
import ShopGrid from "../pages/ShopGrid";
import BusinessListingDetails from "../pages/BusinessListingDetails";
import SearchResults from "../pages/SearchResults";
import EngagementChatPage from "../pages/EngagementChatPage";
import About from "../pages/About";
import Profile from "../pages/Profile";
import EditProfile from "../pages/EditProfile";
import Notifications from "../pages/Notifications";
import Contact from "../pages/Contact";
import SupportCenter from "../pages/SupportCenter";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import TermsAndConditions from "../pages/TermsAndConditions";
import RefundPolicy from "../pages/RefundPolicy";
import ForgotPassword from "../pages/ForgotPassword";
import ResetPassword from "../pages/ResetPassword";
import VerifyEmail from "../pages/VerifyEmail";
import AccountDeletionPage from "../pages/AccountDeletionPage";
import SubscriptionPage from "../pages/SubscriptionPage";
import EarlyUserIncentives from "../pages/EarlyUserIncentives";

const publicRoutes = [
  {
    path: "/",
    component: Home,
  },
  {
    path: "/services",
    component: ShopGrid,
  },
  {
    path: "/login",
    component: LoginRegister,
  },
  {
    path: "/login-register",
    component: LoginRegister,
  },
  {
    path: "/auth/forgot-password",
    component: ForgotPassword,
  },
  {
    path: "/auth/reset-password",
    component: ResetPassword,
  },
  {
    path: "/verify-email",
    component: VerifyEmail,
  },
  {
    path: "/account/delete-request",
    component: AccountDeletionPage,
  },
  {
    path: "/subscription",
    component: SubscriptionPage,
  },
  {
    path: "/admin/early-user-incentives",
    component: EarlyUserIncentives,
  },
  {
    path: "/services-grid",
    component: ShopFilterGrid,
  },
  {
    path: "/cart-page",
    component: CartPage,
  },
  {
    path: "/vendor-profile",
    component: ProductDetails,
  },
  {
    path: "/business-listing/:id",
    component: BusinessListingDetails,
  },
  {
    path: "/search",
    component: SearchResults,
  },
  {
    path: "/engagement-chat/:engagementId",
    component: EngagementChatPage,
  },
  {
    path: "/about",
    component: About,
  },
  {
    path: "/vendors",
    component: SearchResults,
  },
  {
    path: "/profile",
    component: Profile,
  },
  {
    path: "/edit-profile",
    component: EditProfile,
  },
  {
    path: "/notifications",
    component: Notifications,
  },
  {
    path: "/contact",
    component: Contact,
  },
  {
    path: "/support",
    component: SupportCenter,
  },
  {
    path: "/privacy-policy",
    component: PrivacyPolicy,
  },
  {
    path: "/terms",
    component: TermsAndConditions,
  },
  {
    path: "/refund-policy",
    component: RefundPolicy,
  },
  {
    path: "/:id",
    component: BusinessListingDetails,
  },
];

export { publicRoutes };
